import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { AddCircleIcon, IconSize, IconWrapper, Link } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../../translations';

import { PassportIdentityDocumentEnterModal } from './PassportIdentityDocumentEnterModal';

type PassportIdentityDocumentEnterLinkProps = {
   readonly hasAnotherIdentityDocument: boolean;
   readonly patientId: number;
   readonly onIdentityDocumentChanged: (patient: Patient) => Promise<void> | void;
};

export const PassportIdentityDocumentEnterLink = (props: PassportIdentityDocumentEnterLinkProps): JSX.Element => {
   const { onIdentityDocumentChanged } = props;
   const [showModal, toggleShowModal] = useToggle(false);

   const handleIdentityDocumentEntered = useCallback(
      async (patient: Patient): Promise<void> => {
         await onIdentityDocumentChanged(patient);
         toggleShowModal(false);
      },
      [onIdentityDocumentChanged, toggleShowModal]
   );

   return (
      <>
         <Link
            testId={'passportIdentityDocumentEnter'}
            onClick={toggleShowModal}
            label={identityDocumentTranslationKeys.passport.enter.button.label}
            icon={
               <IconWrapper testId={'passportIdentityDocumentEnter'} size={IconSize.SMALLEST}>
                  <AddCircleIcon />
               </IconWrapper>
            }
         />
         {showModal ? (
            <PassportIdentityDocumentEnterModal
               patientId={props.patientId}
               hasAnotherIdentityDocument={props.hasAnotherIdentityDocument}
               onIdentityDocumentEntered={handleIdentityDocumentEntered}
               onCancel={toggleShowModal}
               onSuccess={toggleShowModal}
            />
         ) : null}
      </>
   );
};
